module.exports = __webpack_public_path__ + "img/ch.3fd7684c.svg";